import { render, staticRenderFns } from "./ExternalDamageCard.vue?vue&type=template&id=1938db99&scoped=true"
import script from "./ExternalDamageCard.vue?vue&type=script&lang=ts"
export * from "./ExternalDamageCard.vue?vue&type=script&lang=ts"
import style0 from "./ExternalDamageCard.vue?vue&type=style&index=0&id=1938db99&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1938db99",
  null
  
)

export default component.exports